import {unstable_usePrompt} from "react-router-dom";
import {useBeforeUnloadWarning} from "./useBeforeUnloadWarning";

/** Guards an in-memory delivery checkpoint from accidental browser and in-app navigation. */
export function usePendingDeliveryNavigationGuard(pending: boolean, prompt: string): void {
	useBeforeUnloadWarning(pending);
	unstable_usePrompt({when: pending, message: prompt});
}
